const validate = (values) => {
  const regexExp = /\D/g;
  const errors = {};
  if (!values.name) {
    errors.name = 'Esse campo não pode ficar vazio';
  }
  if (!values.coordinator) {
    errors.coordinator = 'Esse campo não pode ficar vazio';
  }
  if (!values.minFrequency) {
    errors.minFrequency = 'Esse campo não pode ficar vazio';
  }
  if (!values.mediaApproval) {
    errors.mediaApproval = 'Esse campo não pode ficar vazio';
  }
  if (values.durationInDays) {
    if (regexExp.test(values.durationInDays)) {
      errors.durationInDays = 'Esse campo deve conter apenas números positivos';
    }
    if (values.durationInDays < 1) {
      errors.durationInDays = 'Informe um valor acima de 0';
    }
  }
  if (values.workload) {
    if (regexExp.test(values.workload)) {
      errors.workload = 'Esse campo deve conter apenas números positivos';
    }
    if (values.workload < 1) {
      errors.workload = 'Informe um valor acima de 0';
    }
  }
  if (!values.steps.length) {
    errors.steps = 'Esse campo não pode ficar vazio';
  }
  if (values.curriculumGrouped) {
    const concat = values.curriculumGrouped.reduce(
      (acc, item) => acc.concat(item),
      []
    );
    if (!concat.every((item) => item.stepWorkLoad >= 0)) {
      errors.errorGrid = 'Você deve informar o número de aulas da disciplina';
    }
  }
  return errors;
};

export default validate;
